/*
 Copyright (c) 2015, salesforce.com, inc. All rights reserved.

 Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

import {
  GET_JOURNEY_BUILDER_TEMPLATES,
  HAS_JOURNEY_BUILDER_CREATE,
  HAS_JOURNEY_BUILDER_BR,
  HAS_LIGHTNING_HOMEPAGE_BR,
} from '../constants';

import { createMcGetAction, createMcHasPermissionAction, createMcGetBusinessRule } from '../api';

export function getTemplates() {
  return createMcGetAction(
    GET_JOURNEY_BUILDER_TEMPLATES,
    '/interaction/v1/definitionTemplates/?$pageSize=20&$page=1&types=1',
    {}
  );
}

export function hasJourneyBuilderCreatePermission() {
  return createMcHasPermissionAction(HAS_JOURNEY_BUILDER_CREATE, 'InteractionStudio', 'CreateEditExecute');
}

export function hasJourneyBuilderBR() {
  return createMcGetBusinessRule(HAS_JOURNEY_BUILDER_BR, 'INTERACTION_STUDIO', {});
}

export function hasLightningHomepageBR() {
  return createMcGetBusinessRule(HAS_LIGHTNING_HOMEPAGE_BR, 'MC_HOMEPAGE_LIGHTNING_ENABLED', {});
}
